import { DateFormat, formatDate, parseDate } from '@chillibean/component-library';

import { DisplayName } from './DisplayName';
import { StudyArm } from './StudyArm';
import { StudyProcedureRoleDefinition } from './StudyProcedureRoleDefinition';
import { StudyProcedureTaskDefinition } from './StudyProcedureTaskDefinition';
import { StudyTable } from './StudyTable';

export class StudyProtocol {
  constructor(params) {
    this.createdAt = params.createdAt && parseDate(params.createdAt);
    this.id = params.id;
    this.issueDate = params.issueDate && parseDate(params.issueDate, DateFormat.ISO_DATE);
    this.locked = params.locked;
    this.name = params.name;
    this.sites = params.sites;
    this.studyArms = params.studyArms ? params.studyArms.map((studyArm) => new StudyArm(studyArm)) : [];
    this.studyEventDisplayName = new DisplayName(params.studyEventDisplayName);
    this.studyEventsPersisted = params.studyEventsPersisted;
    this.studyProcedureDisplayName = new DisplayName(params.studyProcedureDisplayName);
    this.studyProcedureRoleDefinitions = params.studyProcedureRoleDefinitions
      ? params.studyProcedureRoleDefinitions.map((role) => new StudyProcedureRoleDefinition(role))
      : [];
    this.studyProcedureTaskDefinitions = params.studyProcedureTaskDefinitions
      ? params.studyProcedureTaskDefinitions.map((task) => new StudyProcedureTaskDefinition(task))
      : [];
    this.table = new StudyTable(params.table);
  }

  listParams({ onClick }) {
    return {
      header: this.name,
      id: this.id,
      locked: this.locked,
      onClick: () => onClick(this.id),
      subHeader: formatDate(this.issueDate),
    };
  }
}

export default StudyProtocol;
